




























import { Component, Vue, Prop, Watch } from "vue-property-decorator";

interface IPlugin {
  id: string;
  path: string;
  args: Record<string, string>;
}

@Component({
  components: {}
})
export default class PluginItem extends Vue {
  @Prop() value!: IPlugin;

  readValue() {
    this.id = this.value.id;
    this.path = this.value.path;
    this.args = this.value.args;
  }

  id = this.value.id;
  path = this.value.path;
  args = this.value.args;

  emitValue() {
    const newValue = JSON.parse(JSON.stringify(this.value)) as IPlugin;
    newValue.id = this.id;
    newValue.path = this.path;
    newValue.args = this.args;
    this.$emit("input", newValue);
  }

  @Watch("id")
  onIdChange() {
    this.emitValue();
  }

  @Watch("path")
  onPathChange() {
    this.emitValue();
  }
}
